import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const newsSlice = createSlice({
  name: "news",
  initialState: {
    newsData: [],
    isError: false,
  },

  reducers: {
    fetchNewsSuccess: (state, action) => {
      state.isError = false;
      state.newsData = action.payload;
    },
    fetchNewsFailure: (state) => {
      state.isError = true;
    },
  },
});

export const { fetchNewsSuccess, fetchNewsFailure } = newsSlice.actions;

export const fetchNews = () => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/home`);
    dispatch(fetchNewsSuccess(response.data.market_news));
  } catch (error) {
    dispatch(fetchNewsFailure());
  }
};

export default newsSlice.reducer;
